import { render, staticRenderFns } from "./dashboard.component.vue?vue&type=template&id=c6c2b16c&scoped=true"
import script from "./dashboard.component.vue?vue&type=script&lang=js"
export * from "./dashboard.component.vue?vue&type=script&lang=js"
import style0 from "./dashboard.component.vue?vue&type=style&index=0&id=c6c2b16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c2b16c",
  null
  
)

export default component.exports